<template>
  <div>
  <div class="container pr-3 pl-3 margin-3">
    <div class="row mb-5 pr-3 pl-3" style="margin-top: 8%">
      <div class="pt-md-5 col-md-5 logo-side text-center">
        <img class="mt-md-3 logo-size"
             src="../assets/logo-login.png">
        <p style="padding-top: 0.25em">ยินดีต้อนรับ</p>
<!--        <div style="font-size: 18px">-->
<!--          <div>กองป้องกันการบาดเจ็บ กรมควบคุมโรค</div>-->
<!--          <div>โทร. 0 2590 3888 โทรสาร 0 2590 3893 เว็บไซต์ <a href="https://ddc.moph.go.th/dip">https://ddc.moph.go.th/dip</a></div>-->
<!--        </div>-->
      </div>
      <div class=" col-md-7">
        <div class="text-center">
          <div class="text-head pb-3">
            ระบบรายงานผู้บาดเจ็บหรือเสียชีวิตจากการตกน้ำ จมน้ำ
          </div>
        </div>
        <div class="pt-5 mt-0 login-form">
          <div class="row">
            <div class="offset-md-2 offset-1 col-md-8 col-10">

              <div class="form-group">
                <label >เลือกระดับผู้ใช้</label>
<!--                <select v-model="login_form.user_type_id" class="browser-default custom-select" @change="clearSelect()">-->
<!--                  <option value="" disabled hidden>ระดับผู้ใช้</option>-->
<!--                  <option value="0">ส่วนกลาง</option>-->
<!--                  <option value="1">ระดับเขต</option>-->
<!--                  <option value="2">ระดับจังหวัด</option>-->
<!--                  <option value="3">ระดับอำเภอ</option>-->
<!--                  <option value="4">ระดับโรงพยาบาล</option>-->
<!--                </select>-->
                <multiselect
                  @input="clearSelect()"
                  v-model="user_type"
                  :options="optionUserLevel"
                  label="name"
                  select-label=""
                  selectedLabel=""
                  deselect-label=""
                  placeholder="ระดับผู้ใช้"
                  track-by="name">
                </multiselect>
              </div>

              <template v-if="login_form.user_type_id == 1">
                <div class="form-group">
                  <label >ระดับเขต</label>
<!--                  <select v-model="login_form.area_id" class="browser-default custom-select">-->
<!--                    <option value="" disabled hidden>ระดับเขต</option>-->
<!--                    <option value="1">เขต 1</option>-->
<!--                    <option value="2">เขต 2</option>-->
<!--                    <option value="3">เขต 3</option>-->
<!--                    <option value="4">เขต 4</option>-->
<!--                    <option value="5">เขต 5</option>-->
<!--                    <option value="6">เขต 6</option>-->
<!--                    <option value="7">เขต 7</option>-->
<!--                    <option value="8">เขต 8</option>-->
<!--                    <option value="9">เขต 9</option>-->
<!--                    <option value="10">เขต 10</option>-->
<!--                    <option value="11">เขต 11</option>-->
<!--                    <option value="12">เขต 12</option>-->
<!--                    <option value="13">สปคม</option>-->
<!--                  </select>-->
                  <multiselect
                    v-model="login_form.area_id"
                    :options="optionArea"
                    label="name"
                    select-label=""
                    selectedLabel=""
                    deselect-label=""
                    placeholder="ระดับเขต"
                    track-by="name">
                  </multiselect>
                </div>
              </template>

              <template v-if="login_form.user_type_id == 2">
                <div class="form-group">
                  <label >จังหวัด</label>
                  <multiselect
                    v-model="login_form.province_id"
                    :options="optionProvince"
                    label="name"
                    select-label=""
                    selectedLabel=""
                    deselect-label=""
                    placeholder="เลือกจังหวัด"
                    track-by="name">
                  </multiselect>
                </div>
              </template>

              <template v-if="login_form.user_type_id == 3">
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <label >จังหวัด</label>
                      <multiselect
                        v-model="login_form.province_id"
                        @input="getDistricts(login_form.province_id)"
                        :options="optionProvince"
                        label="name"
                        select-label=""
                        selectedLabel=""
                        deselect-label=""
                        placeholder="เลือกจังหวัด"
                        track-by="name">
                      </multiselect>
                    </div>
                    <div class="col-md-6 col-12">
                      <label >อำเภอ</label>
                      <multiselect
                        v-model="login_form.district_id"
                        :options="optionDistrict"
                        label="name"
                        select-label=""
                        selectedLabel=""
                        deselect-label=""
                        placeholder="เลือกอำเภอ"
                        track-by="name"
                        :allow-empty="false" >
                      </multiselect>
                    </div>
                  </div>
                </div>
              </template>

              <template v-if="login_form.user_type_id == 4">
                <div class="form-group">
                  <label >จังหวัด</label>
                  <multiselect
                    v-model="login_form.province_id"
                    @input="getHospitals(login_form.province_id)"
                    :options="optionProvince"
                    label="name"
                    select-label=""
                    selectedLabel=""
                    deselect-label=""
                    placeholder="เลือกจังหวัด"
                    track-by="name">
                  </multiselect>
                </div>
              </template>

              <template v-if="login_form.user_type_id == 4 && login_form.province_id !=''">
                <div class="form-group">
                  <label >โรงพยาบาล</label>
                  <multiselect
                    v-model="login_form.hospital"
                    :options="optionHospital"
                    label="name"
                    select-label=""
                    selectedLabel=""
                    deselect-label=""
                    placeholder="เลือกโรงพยาบาล"
                    track-by="id">
                  </multiselect>
                </div>
              </template>



              <template v-if="login_form.user_type_id === 0">
                <div class="form-group">
                  <label for="InputPassword">รหัสผ่าน</label>
                  <input v-model="login_form.password" type="password" class="form-control">
                </div>
              </template>
              <template v-if="login_form.user_type_id == 1 && login_form.area_id !=''">
                <div class="form-group">
                  <label for="InputPassword">รหัสผ่าน</label>
                  <input v-model="login_form.password" type="password" class="form-control">
                </div>
              </template>
              <template v-if="login_form.user_type_id == 2 && login_form.province_id != '' ">
                <div class="form-group">
                  <label for="InputPassword">รหัสผ่าน</label>
                  <input v-model="login_form.password" type="password" class="form-control">
                </div>
              </template>
              <template v-if="(login_form.user_type_id == 3 && login_form.province_id != '') && login_form.district_id != '' ">
                <div class="form-group">
                  <label for="InputPassword">รหัสผ่าน</label>
                  <input v-model="login_form.password" type="password" class="form-control">
                </div>
              </template>
              <template v-if="(login_form.user_type_id == 4 && login_form.province_id != '') && login_form.hospital != ''">
                <div class="form-group">
                  <label for="InputPassword">รหัสผ่าน</label>
                  <input v-model="login_form.password" type="password" class="form-control">
                </div>
              </template>
            </div>
          </div>
          <div class="text-center">
            <a @click="contact" class="forget-pass" style="font-size: 17px;text-decoration: underline;text-align: center">
              ลืมรหัสผ่าน
            </a>
          </div>
          <div class="pt-0 text-center" >
            <b-button @click="login" variant="light" class="w-50 btn-login pb-0 pt-0">
              เข้าสู่ระบบ
            </b-button>
          </div>

          <div class="pt-1 pb-3 text-center"  >
            <b-button href="https://drowningreport.ddc.moph.go.th/satsystem/public/satdrowning.pdf" variant="light" class="w-50 btn-download pb-0 pt-0" >
              คู่มือการใช้งาน
            </b-button>
          </div>
        </div>
      </div>
    </div>
    </div>
    <footer-view></footer-view>
<!--    <pre class="alert-success">{{login_form}}</pre>-->
<!--            <pre class="alert-danger">{{optionProvince}}</pre>-->
  </div>
</template>

<script>
    import { mapState } from "vuex";
    import Multiselect from 'vue-multiselect';
    import FooterView from "./FooterView";

    export default {
        name: "LoginView",
        props: {
            id: { default: null }
        },
        components: {
          FooterView,
            Multiselect
        },
        created(){
            this.$store.dispatch("Common/setProvinces");
            // this.$store.dispatch("Common/setHospital");
            // this.$store.dispatch("Common/setDistrict");
            this.checkLogin();
        },
        computed: {
            ...mapState({
                form : state=>{
                    return state.Auth.form;
                },
                optionProvince : state=>{
                    return state.Common.provinces;
                },
                optionDistrict : state=>{
                    return state.Common.districts;
                },
                optionHospital : state=>{
                    return state.Common.hospitals;
                },
                login_form : state=>{
                    return state.Auth.login_form;
                },
                user_login : state=>{
                    return state.Auth.user_login
                },
                accessToken : state=>{
                    return state.Auth.accessToken
                }
            })
        },
        data() {
            return {
              user_type : '',
              optionArea : [
                {
                  'id': 1,
                  'name' : 'เขต 1'
                },
                {
                  'id': 2,
                  'name' : 'เขต 2'
                },
                {
                  'id': 3,
                  'name' : 'เขต 3'
                },
                {
                  'id': 4,
                  'name' : 'เขต 4'
                },
                {
                  'id': 5,
                  'name' : 'เขต 5'
                },
                {
                  'id': 6,
                  'name' : 'เขต 6'
                },
                {
                  'id': 7,
                  'name' : 'เขต 7'
                },
                {
                  'id': 8,
                  'name' : 'เขต 8'
                },
                {
                  'id': 9,
                  'name' : 'เขต 9'
                },
                {
                  'id': 10,
                  'name' : 'เขต 10'
                },
                {
                  'id': 11,
                  'name' : 'เขต 11'
                },
                {
                  'id': 12,
                  'name' : 'เขต 12'
                },
                {
                  'id': 13,
                  'name' : 'สปคม'
                }
              ],
              optionUserLevel : [
                {
                  'id': 0,
                  'name' : 'ส่วนกลาง'
                },
                {
                  'id': 1,
                  'name' : 'ระดับเขต'
                },
                {
                  'id': 2,
                  'name' : 'ระดับจังหวัด'
                },
                {
                  'id': 3,
                  'name' : 'ระดับอำเภอ'
                },
                // {
                //   'id': 4,
                //   'name' : 'ระดับโรงพยาบาล'
                // }
              ],
            };
        },
        methods: {
            checkLogin(){
                if(this.user_login !== 1 && this.user_login !== null){
                    this.$router.push({
                      name: 'MenuView'
                    })
                }
            },
          contact(){
            this.$router.push({
              name:"ContactView"
            });
          },
            login(){
                if(!this.user_type){
                    this.showErrorFill('กรุณาเลือกระดับผู้ใช้');
                }
                else if(this.login_form.user_type_id == 0 && this.login_form.password ==''){
                    this.showErrorFill('กรุณากรอก password ให้ถูกต้อง');
                }
                else if(this.login_form.user_type_id == 1 && this.login_form.area_id ==''){
                    this.showErrorFill('กรุณาเลือกเขต');
                }
                else if(this.login_form.user_type_id == 1 && this.login_form.area_id !='' && this.login_form.password =='' ) {
                    this.showErrorFill('กรุณากรอก password ให้ถูกต้อง');
                }
                else if(this.login_form.user_type_id == 2 && this.login_form.province_id =='' ) {
                    this.showErrorFill('กรุณาเลือกจังหวัด');
                }
                else if(this.login_form.user_type_id == 2 && this.login_form.province_id != '' && this.login_form.password =='' ) {
                    this.showErrorFill('กรุณากรอก password ให้ถูกต้อง');
                }
                else if(this.login_form.user_type_id == 3 && this.login_form.province_id == '') {
                    this.showErrorFill('กรุณาเลือกจังหวัด');
                }
                else if(this.login_form.user_type_id == 3 && this.login_form.province_id != '' && this.login_form.district_id == '') {
                    this.showErrorFill('กรุณาเลือกอำเภอ');
                }
                else if(this.login_form.user_type_id == 3 && this.login_form.province_id != '' && this.login_form.district_id != '' && this.login_form.password == '' ) {
                    this.showErrorFill('กรุณากรอก password ให้ถูกต้อง');
                }
                else if(this.login_form.user_type_id == 4 && this.login_form.hospital == '' ) {
                    this.showErrorFill('กรุณาเลือกโรงพยาบาล');
                }
                else if(this.login_form.user_type_id == 4 && this.login_form.hospital != '' && this.login_form.province_id == '' ) {
                    this.showErrorFill('กรุณาเลือกจังหวัด');
                }
                else if(this.login_form.user_type_id == 4 && this.login_form.hospital != '' && this.login_form.province_id != '' && this.login_form.password == '') {
                    this.showErrorFill('กรุณากรอก password ให้ถูกต้อง');
                }
                else{
                    let data = {
                        area_id: this.login_form.area_id.id,
                        user_type_id: this.login_form.user_type_id,
                        password: this.login_form.password,
                        province_id: this.login_form.province_id.code,
                        district_id: this.login_form.district_id.id,
                        hospital_code: this.login_form.hospital.code_5,
                    };
                    this.$store.dispatch("Auth/login",data).then(()=>{
                        if(!this.accessToken){
                            this.showErrorFill('password ไม่ถูกต้อง');
                        }
                        else{
                            this.goToStatusPage();
                        }
                    })
                }
            },
            goToStatusPage(){
                this.$router.push({
                    name:"MenuView"
                });
            },
            validPass: function (password) {
                var pass = /^Sadncd\d+$/;
                if(password.match(pass)){
                    return true;
                }
                else{
                    return false;
                }
            },
            validPhoneNumber: function (phone_number) {
                var re = /^[0][0-9]{9}$/;
                if(phone_number.match(re)){
                    return true;
                }
                else{
                    return false;
                }
            },
            getDistricts(province){
              console.log(province)
                if(province){
                    this.login_form.district_id = "";
                    this.$store.dispatch('Common/setDistrict',province.code);
                }
            },
            getHospitals(province){
                if(province){
                    this.login_form.hospital = "";
                    this.$store.dispatch('Common/setHospital',province.code);
                }
            },
            showErrorFill(message){
                const Toast = this.$swal.fire({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    type: 'error',
                    title: message
                })
            },
            clearSelect(){
              console.log(this.login_form.user_type)
              this.login_form.user_type_id = this.user_type.id
                if (this.login_form.user_type_id == 0 ){
                    this.login_form.area_id = "";
                    this.login_form.province_id = "";
                    this.login_form.district_id = "";
                    this.login_form.hospital = "";
                    this.login_form.password = "";
                } else if (this.login_form.user_type_id == 1){
                    this.login_form.area_id = "";
                    this.login_form.province_id = "";
                    this.login_form.district_id = "";
                    this.login_form.hospital = "";
                    this.login_form.password = "";
                }else if (this.login_form.user_type_id == 2){
                    this.login_form.area_id = "";
                    this.login_form.province_id = "";
                    this.login_form.district_id = "";
                    this.login_form.hospital = "";
                    this.login_form.password = "";
                }else if (this.login_form.user_type_id == 3) {
                    this.login_form.area_id = "";
                    this.login_form.province_id = "";
                    this.login_form.district_id = "";
                    this.login_form.hospital = "";
                    this.login_form.password = "";
                }else {
                    this.login_form.area_id = "";
                    this.login_form.province_id = "";
                    this.login_form.district_id = "";
                    this.login_form.hospital = "";
                    this.login_form.password = "";
                }
            },
        }
    }
</script>

<style scoped>
  .footer-div{
    padding-bottom: 15px;
    padding-top: 15px;
    background-color: #E7E7E7;
    color: #006738;
    font-size: 20px;
    line-height: 15px;
    vertical-align: bottom;
    width: 100%;
  }
  .login-form{
    background-color: #006738;
    color: white;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 24px;
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 2px;
    padding-bottom: 1em;
  }

  .forget-pass{
    color: white!important;
    text-decoration: none;
    background-color: transparent;
  }
  .login-form input{
    font-size: 24px;
    font-weight: 700;
  }

  .logo-size{
    height: 180px;
  }

  .logo-side{
    color: #006738;
    font-weight: 700;
    font-size: 44px;
  }

  .text-center{
    margin: 0 auto;
  }

  .btn-login{
    color: #006738;
    font-size: 25px;
    font-weight: 700;
  }

  .btn-register{
    color: #FFFFFF;
    background-color: #42b983;
    font-size: 25px;
    font-weight: 700;
  }

  .btn-download{
    color: #FFFFFF;
    background-color: transparent;
    font-size: 25px;
    font-weight: 700;
  }

  .custom-control-input:checked~.custom-control-label::before {
    color: whitesmoke;
    border-color: white;
    background-color: #006738;
  }

  .custom-control-label::before {
    background-color: #006738;
    border: white solid 2px;
  }

  /*@media only screen and (max-width: 1200px) {*/
  /*    .text-head{*/
  /*        color: #006738;*/
  /*        font-size: 28px;*/
  /*    }*/
  /*}*/

  .text-head{
    color: #006738;
    font-size: 42px;
    line-height: 45px;
  }

  @media only screen and (max-width: 992px) {
    .logo-size{
      height: 200px;
    }

    .logo-side{
      font-size: 36px;
    }
    .text-head{
      color: #006738;
      font-size: 36px;
      line-height: 40px;
    }
  }

  @media only screen and (max-width: 767px) {
    .logo-size{
      height: 160px;
    }

    .logo-side{
      font-size: 36px;
    }

    .text-head{
      color: #006738;
      font-size: 36px;
      line-height: 40px;
      margin-top: 1em;
    }
  }
  @media only screen and (max-width: 499px) {
    .logo-size{
      height: 100px;
    }

    .logo-side{
      font-size: 30px;
    }

    .text-head{
      color: #006738;
      font-size: 34px;
      line-height: 38px;
      margin-top: 1em;
    }

    .login-form{
      font-size: 17px;
    }

    .login-form input{
      font-size: 17px;
    }
    .btn-login{
      color: #006738;
      font-size: 17px;
      font-weight: 700;
    }
  }

  .custom-select {
    font-size: 20px !important;
    color: #606060 !important;
    font-weight: 700 !important;
  }

</style>
